import { render, staticRenderFns } from "./BannerCreate.vue?vue&type=template&id=40112938&scoped=true&"
import script from "./BannerCreate.vue?vue&type=script&lang=js&"
export * from "./BannerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40112938",
  null
  
)

export default component.exports